<div *ngIf="drawerName">
    <aside class="right-side-drawer" [style.width]="drawerWidth">
        <div [style.width.px]='drawerWidth' class="flex-containment">
            <header class="right-side-drawer-header info-tile-alt heading-row" *ngIf="drawerTitle">
                <div class="title-container">
                    <div>
                        <h2><b>{{drawerTitle}}</b></h2>
                    </div>
                    <div *ngIf="drawerName==='email'">
                        <a class="link-button-top-border-orange tips" (click)="showEmailTipsModel()">
                            <i class="fa fa-lightbulb upload-data-icon" aria-hidden="true"></i>&nbsp;Tips
                        </a>
                    </div>
                </div>
                <!-- TODO: Fix the following change resetRightSideDrawerData-->
                <div class="drawer-close" (click)="_rightSideDrawerService.closeRightSideDrawer()"><i
                        class="fas fa-times" aria-hidden="true"></i></div>
            </header>
            <add-an-employee-form *ngIf="drawerName==='add-an-employee-form'"
                class="right-side-drawer-content"></add-an-employee-form>
            <ei-edit-single-employee *ngIf="drawerName==='ei-edit-single-employee'"
                class="right-side-drawer-content"></ei-edit-single-employee>
            <ei-delete-single-employee *ngIf="drawerName==='ei-delete-single-employee'"
                class="right-side-drawer-content"></ei-delete-single-employee>
            <ei-delete-multiple-employee *ngIf="drawerName==='ei-delete-multiple-employee'"
                class="right-side-drawer-content"></ei-delete-multiple-employee>
            <ep-add-activity *ngIf="drawerName==='ep-add-activity'" class="right-side-drawer-content"></ep-add-activity>
            <ep-edit-activity *ngIf="drawerName==='ep-edit-activity'"
                class="right-side-drawer-content"></ep-edit-activity>
            <ep-add-projects *ngIf="drawerName==='ep-add-project'" class="right-side-drawer-content"
                [drawerTitle]="drawerTitle" [calledFromEditSurvey]="data"></ep-add-projects>
            <add-an-entity *ngIf="drawerName==='add-an-entity'" class="right-side-drawer-content"></add-an-entity>
            <edit-an-entity *ngIf="drawerName==='edit-an-entity'" class="right-side-drawer-content"></edit-an-entity>
            <!--TODO: Check changes on create-study -->
            <create-study (drawerWidth)="drawerWidthHandeler($event)" *ngIf="drawerName==='create-study'"
                class="right-side-drawer-content"></create-study>

            <!--<home-create-new-engagement (drawerWidth)="drawerWidthHandeler($event)" (mandatoryindicator)="mandatoryindicatorChange($event)" [engagementNums]="data.engagementNums" *ngIf="drawerName==='home-create-new-engagement'" class="right-side-drawer-content"></home-create-new-engagement>-->

            <home-edit-an-engagement (drawerWidth)="drawerWidthHandeler($event)"
                *ngIf="drawerName==='home-edit-an-engagement'" class="right-side-drawer-content"
                (drawerTitle)="setDrawerTitle($event)" [data]="data"></home-edit-an-engagement>
            <assign-survey-respondent [engagementId]="data.engagementId" [surveyId]="data.surveyId"
                [itemId]="data.itemId" [canSMEAddProjects]="data.canSMEAddProjects"
                *ngIf="drawerName==='assign-survey-respondent'"
                class="right-side-drawer-content"></assign-survey-respondent>
            <comments (drawerWidth)="drawerWidthHandeler($event)" *ngIf="drawerName==='comments'"
                class="right-side-drawer-content"></comments>
            <aa-add-activities *ngIf="drawerName==='aa-add-activities'"
                class="right-side-drawer-content"></aa-add-activities>
            <aa-add-projects *ngIf="drawerName==='aa-add-projects'" class="right-side-drawer-content"></aa-add-projects>
            <time-survey-employee-list *ngIf="drawerName==='time-survey-employee-list'"
                class="right-side-drawer-content"></time-survey-employee-list>
            <ei-records (drawerWidth)="drawerWidthHandeler($event)" *ngIf="drawerName==='ei-records'"
                class="right-side-drawer-content"></ei-records>
            <add-user-form *ngIf="drawerName==='add-user-form'" class="right-side-drawer-content"></add-user-form>
            <add-update-masterActivity *ngIf="drawerName==='add-update-masterActivity'"
                class="right-side-drawer-content"></add-update-masterActivity>
            <assign-bulk-sme *ngIf="drawerName==='assign-bulk-sme'" class="right-side-drawer-content"></assign-bulk-sme>
            <add-client-user-form *ngIf="drawerName==='add-client-user-form'"
                class="right-side-drawer-content"></add-client-user-form>
            <div *ngIf="isFileUpload" class="file-upload-section">
                <custom-uploader (drawerWidth)="drawerWidthHandeler($event)" [uploaderTitle]="drawerTitle"
                    [uploadedFileName]="data.downloadFileName" [uploadedFileType]="data.filetype"
                    [surveyCategory]="data.surveyCategory" [allowedFileType]="data.supportedFileType"
                    [uploadData]="data" [hideUploadSection]="hideUploadSection" *ngIf="isFileUpload">
                </custom-uploader>
            </div>

            <edit-expense-survey *ngIf="drawerName==='edit-expense-survey'"
                class="right-side-drawer-content"></edit-expense-survey>
            <expense-submit-history *ngIf="drawerName==='expense-submit-history'"
                class="right-side-drawer-content"></expense-submit-history>
                      <expense-survey-comment *ngIf="drawerName==='expense-survey-comment'"
                class="right-side-drawer-content"></expense-survey-comment>

            <email (drawerWidth)="drawerWidthHandeler($event)" *ngIf="drawerName==='email'"
                class="right-side-drawer-content"></email>
            <manage-business-component-screen (drawerWidth)="drawerWidthHandeler($event)" [engagementId]="data"
                *ngIf="drawerName==='manage-business-component-screen'" class="right-side-drawer-content">
            </manage-business-component-screen>

            <rcn-create-business-component *ngIf="drawerName==='create-business-component'"
                class="right-side-drawer-content" [engagementId]="data.studyId">
            </rcn-create-business-component>
        </div>

        <spinner *ngIf="isLoading"></spinner>

    </aside>
    <div id="cover">
    </div>
</div>

<savechangesconfirmation [title]="'Close '+ _rightSideDrawerService.drawerName + ' drawer?'"
    [message]="'Do you want to discard the changes and close the drawer?'" (confirmBoxHandler)="confirm($event)"
    *ngIf="showSaveChangesModal"></savechangesconfirmation>

<jw-modal id="emailTips-modal" [ngClass]="showEmailTips ? 'showGuideModal' : 'hideGuideModal'">
    <email-tips-modal *ngIf="showEmailTips"></email-tips-modal>
</jw-modal>
